import { render, staticRenderFns } from "./Rule60ApplicationInstructions.vue?vue&type=template&id=00470d4c&scoped=true"
import script from "./Rule60ApplicationInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule60ApplicationInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule60ApplicationInstructions.vue?vue&type=style&index=0&id=00470d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00470d4c",
  null
  
)

export default component.exports